import { main } from './cli/index.js';

await main();
